import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-[#1e2a38] text-white py-20 px-4" data-id="element-38">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-39">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-40">
          <defs data-id="element-41">
            <pattern id="hero-waves" x="0" y="0" width="100" height="20" patternUnits="userSpaceOnUse" data-id="element-42">
              <path d="M0 10 Q25 20 50 10 T100 10" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-43" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hero-waves)" data-id="element-44" />
        </svg>
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-[#1e2a38] via-transparent to-[#1e2a38] opacity-80" data-id="element-45"></div>

      <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left space-y-8" data-id="element-47">
          <div className="inline-block px-4 py-1 rounded-full border border-[#c9a07a] text-[#c9a07a] text-sm font-medium tracking-wide mb-4" data-id="element-48">
            MENOPAUSE SLEEP EDITION
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight" data-id="element-49">
            If you wake up at{' '}
            <span className="text-[#c9a07a] italic" data-id="element-50">3:17AM</span>… <br data-id="element-51" />
            read this first.
          </h1>

          <p className="text-xl text-gray-300 leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-52">
            A 7-night system to stop the 3–4AM "wide awake" loop and get back to
            sleep fast.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4" data-id="element-53">
            <Button variant="primary" icon data-id="element-54">
              Get The Reset - $17
            </Button>
          </div>

          <p className="text-sm text-[#c9a07a] mt-4" data-id="element-55">
            Includes: Bedside Decision Card + 7 Night Tracker
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-56">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-700/50" data-id="element-57">
            <img src="https://cdn.magicpatterns.com/uploads/iPmKhJipvDZeNMWwcoPyZX/heylloyd-image-1770073637680.png" alt="The 3AM Wake-Up Reset on Tablet" className="w-full h-auto object-cover" data-id="element-58" />
            {/* Glow effect behind image */}
            <div className="absolute -inset-4 bg-[#c9a07a] opacity-20 blur-2xl -z-10 rounded-full" data-id="element-59"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}